import { createContext } from "react";

const boardContext = createContext({
  isUserLoggedIn: false,
  activeToolItem: "",
  toolActionType: "",
  elements: [],
  history: [[]],
  index: 0,
  canvasId: "",
  sharedEmails: [],
  socket: null,
  setElements: () => { },
  setSharedEmails: () => { },
  boardMouseDownHandler: () => { },
  setCanvasId: () => { },
  changeToolHandler: () => { },
  boardMouseMoveHandler: () => { },
  boardMouseUpHandler: () => { },
  setUserLoginStatus: () => { },
  setHistory: () => { },
  currentUser: null,
  setCurrentUser: () => { }
});


export default boardContext;
